import { render, staticRenderFns } from "./performance_rules.vue?vue&type=template&id=003331fe&scoped=true&"
import script from "./performance_rules.vue?vue&type=script&lang=js&"
export * from "./performance_rules.vue?vue&type=script&lang=js&"
import style0 from "./performance_rules.vue?vue&type=style&index=0&id=003331fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003331fe",
  null
  
)

export default component.exports